import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LOGO_WHITE = "/brand/MFP_white.svg";

export default function DatenschutzPage() {
  return (
    <div className="bg-mfp-bg text-white min-h-screen" data-testid="datenschutz-page">
      <header className="border-b border-white/10">
        <div className="max-w-4xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="datenschutz-back">
            <ArrowLeft className="h-4 w-4" /> <span className="text-xs uppercase tracking-widest">Zurück</span>
          </Link>
          <img src={LOGO_WHITE} alt="MediaFly Production" className="h-8 w-auto" />
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 md:px-8 py-12 md:py-20">
        <h1 className="font-display text-4xl md:text-5xl uppercase mb-8">Datenschutz</h1>

        <div className="space-y-5 text-sm md:text-base leading-relaxed text-white/90">
          <section>
            <h2 className="font-display text-xl uppercase mt-4">1. Verantwortlicher</h2>
            <p>
              MediaFly Production<br />
              Emre Ucar<br />
              Am Obereich 56, 64832 Babenhausen<br />
              Telefon: +49 170 4444355<br />
              E-Mail: kontakt@mediafly-production.de
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl uppercase mt-6">2. Erhebung personenbezogener Daten</h2>
            <p>
              Wir erheben personenbezogene Daten nur dann, wenn Sie uns diese von sich aus
              mitteilen, insbesondere über unser Kontaktformular, per WhatsApp (
              <a href="https://wa.me/491704444355" className="underline hover:text-mfp-gold">
                wa.me/491704444355
              </a>
              ) oder telefonisch. Folgende Daten werden verarbeitet: Name, Telefonnummer,
              E-Mail-Adresse, ausgewähltes Paket, Angabe zu Drohnennutzung, sowie Ihre
              Nachricht. Rechtsgrundlage: Art. 6 Abs. 1 lit. b und f DSGVO.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl uppercase mt-6">3. Google Tag Manager</h2>
            <p>
              Diese Website nutzt den Google Tag Manager, der es ermöglicht, Website-Tags über
              eine Oberfläche zu verwalten. Der Google Tag Manager setzt selbst keine Cookies
              und erfasst keine personenbezogenen Daten, kann jedoch andere Tags auslösen, die
              Daten erfassen. Der Einsatz erfolgt nur nach Ihrer Einwilligung gemäß
              Art. 6 Abs. 1 lit. a DSGVO (Google Consent Mode v2).
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl uppercase mt-6">4. Meta Pixel (Facebook Pixel)</h2>
            <p>
              Wir nutzen auf dieser Website das Meta Pixel der Meta Platforms Ireland Ltd.,
              um Ihnen passgenaue Werbung auszuspielen und die Wirksamkeit unserer Kampagnen
              zu messen. Das Meta Pixel wird nur nach Ihrer ausdrücklichen Einwilligung
              aktiviert (Art. 6 Abs. 1 lit. a DSGVO). Weitere Infos:
              {" "}
              <a className="underline hover:text-mfp-gold" href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener noreferrer">
                Facebook Datenrichtlinie
              </a>.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl uppercase mt-6">5. Cookies</h2>
            <p>
              Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem
              Endgerät gespeichert werden. Notwendige Cookies werden automatisch gesetzt,
              alle weiteren (Statistik, Marketing) nur mit Ihrer Einwilligung. Sie können Ihre
              Cookie-Einstellungen jederzeit über den Link „Cookie-Einstellungen" im Footer ändern.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl uppercase mt-6">6. Tracking nur nach Zustimmung</h2>
            <p>
              Sämtliche Analyse- und Marketing-Technologien (inkl. Google Tag Manager und
              Meta Pixel) werden ausschließlich nach Ihrer expliziten Zustimmung im
              Cookie-Banner aktiviert. Ohne Einwilligung erfolgt kein Tracking.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl uppercase mt-6">7. Ihre Rechte</h2>
            <p>Sie haben folgende Rechte:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1 text-white/80">
              <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
              <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
              <li>Recht auf Löschung (Art. 17 DSGVO)</li>
              <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
              <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
              <li>Widerspruchsrecht (Art. 21 DSGVO)</li>
              <li>Recht auf Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
            </ul>
            <p className="mt-2">
              Zur Ausübung Ihrer Rechte genügt eine formlose Nachricht an kontakt@mediafly-production.de.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl uppercase mt-6">8. Speicherdauer</h2>
            <p>
              Wir speichern Ihre Daten nur so lange, wie es für die Bearbeitung Ihrer Anfrage
              oder aufgrund gesetzlicher Aufbewahrungspflichten erforderlich ist.
            </p>
          </section>

          <p className="text-white/50 text-xs mt-8">
            Stand: {new Date().toLocaleDateString("de-DE")}
          </p>
        </div>
      </main>
    </div>
  );
}
